import { noop } from 'lodash'

import { useState, useCallback } from 'react'

export function usePopupWithConfirmation(
  onConfirm: (...args: any[]) => any = noop,
  onCancel: (...args: any[]) => any = noop
) {
  const [dialogOpen, setDialogOpen] = useState(false)
  const handleOpen = useCallback(() => {
    setDialogOpen(true)
  }, [setDialogOpen])
  const handleCancel = useCallback(() => {
    onCancel()
    setDialogOpen(false)
  }, [onCancel])
  const handleConfirm = useCallback(() => {
    onConfirm()
    setDialogOpen(false)
  }, [onConfirm, setDialogOpen])
  return {
    open: dialogOpen,
    handleCancel,
    handleOpen,
    handleConfirm,
  }
}
